/* eslint-disable no-restricted-globals */
import React, { useLayoutEffect, useState } from 'react';
import { HamiltonDatepicker as Datepicker } from '@amzn/atoz-web/Datepicker';
import { WeekRowDimension } from '../dimensions.consts';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { getDateId, WEEK_ROW, WEEK_ROW_DATEPICKER } from '../testids.consts';
import { validateDayElements, getLocalJSDate, findDateFromDayElement } from '../utils';
import { DateTime } from 'luxon';
import { createDTDayInDefaultTZ } from '@amzn/atoz-shiftapp-utilities';
export var getWeekStartAttribute = function (visibleDayElements) {
    if (!visibleDayElements || visibleDayElements.length < 1)
        return;
    var startDate = findDateFromDayElement(visibleDayElements[0]);
    if (!startDate)
        return;
    return "".concat(startDate === null || startDate === void 0 ? void 0 : startDate.getFullYear(), "-").concat((startDate === null || startDate === void 0 ? void 0 : startDate.getMonth()) + 1, "-").concat(startDate === null || startDate === void 0 ? void 0 : startDate.getDate());
};
var WeekRow = function (_a) {
    var selectedDate = _a.selectedDate, onSelectedDateChange = _a.onSelectedDateChange, _b = _a.locale, locale = _b === void 0 ? 'en-US' : _b, emitErrorLog = _a.emitErrorLog;
    var _c = useState(document.querySelectorAll('.visible-week-row > .react-datepicker__day')), visibleDayElements = _c[0], setVisibleDayElements = _c[1];
    var _d = useState(-1), visibleRowIndex = _d[0], setVisibleRowIndex = _d[1];
    var _e = useState(-1), displayingMonth = _e[0], setDisplayingMonth = _e[1];
    useLayoutEffect(function () {
        var monthContainer = document.querySelectorAll('.react-datepicker__month-container');
        if (monthContainer.length === 0 && emitErrorLog) {
            emitErrorLog('Something wrong with datepicker as the calendar is not displaying');
        }
        /*
        Upon selecting a date from a different month, we must wait for the datepicker to finish re-render
        the new month before attempting to locate the week that contains the selected date within
        the newly painted month
        */
        var selectedJSDate = getLocalJSDate(selectedDate);
        if (selectedJSDate.getMonth() !== displayingMonth) {
            return;
        }
        var targetDateId = getDateId(selectedJSDate);
        var weekRows = document.querySelectorAll(".react-datepicker__week");
        weekRows.forEach(function (weekRow, weekIdx) {
            var days = weekRow.querySelectorAll('.react-datepicker__day');
            for (var i = 0; i < days.length; i++) {
                var dayContent = days[i].querySelector('.day-content');
                if (dayContent.getAttribute('id') === targetDateId) {
                    if (validateDayElements(days, emitErrorLog)) {
                        setVisibleDayElements(days);
                        setVisibleRowIndex(weekIdx);
                    }
                    break;
                }
            }
        });
    }, [selectedDate, displayingMonth]);
    useLayoutEffect(function () {
        var weekRows = document.querySelectorAll(".react-datepicker__week");
        if (visibleRowIndex < 0 ||
            !weekRows ||
            visibleRowIndex >= weekRows.length)
            return;
        weekRows[visibleRowIndex].classList.add('visible-week-row');
        var dayLabelRow = document.querySelector(".react-datepicker__day-names");
        if (!dayLabelRow)
            return;
        dayLabelRow.setAttribute('aria-hidden', 'true');
    });
    return (React.createElement(WeekRowWrapper, { "data-testid": WEEK_ROW, "data-week-start-date": getWeekStartAttribute(visibleDayElements) },
        React.createElement(Datepicker, { inline: true, formatWeekDay: function (day) {
                return day.substring(0, 3).toLocaleUpperCase();
            }, selected: getLocalJSDate(selectedDate), onChange: function (date) {
                onSelectedDateChange(createDTDayInDefaultTZ(date));
            }, setDisplayingMonth: setDisplayingMonth, displayingMonth: displayingMonth, dataTestId: WEEK_ROW_DATEPICKER, locale: locale, overrideTodayDate: getLocalJSDate(DateTime.now()) })));
};
var WeekRowWrapper = styledWithTheme('div')(function () {
    var marginBottom = WeekRowDimension.marginBottom, marginLeft = WeekRowDimension.marginLeft, day = WeekRowDimension.day, width = WeekRowDimension.width;
    return " \n        width: ".concat(width, ";\n        margin-left: ").concat(marginLeft, ";\n        margin-bottom: ").concat(marginBottom, ";\n        \n        .react-datepicker__day-name{\n            width: ").concat(day.width, ";\n            margin: ").concat(day.margin, ";\n        }\n\n        .react-datepicker__day {\n            border: 0px !important;\n            width: ").concat(day.width, ";\n            height: ").concat(day.height, ";\n            padding-bottom: ").concat(day.verticalPadding, ";\n            padding-top: ").concat(day.verticalPadding, ";\n            margin: ").concat(day.margin, ";\n            line-height: ").concat(day.verticalPadding, ";\n        }\n\n        .datepicker-custom-header {\n            display: none\n        }\n\n        .visible-week-row {\n            display: block !important\n        }\n\n        .react-datepicker__week {\n            display: none\n        }\n    ");
});
var MemorizedWeekRow = React.memo(WeekRow);
export { MemorizedWeekRow as WeekRow };
